import React from 'react';
import { Route, Switch } from "react-router-dom";
import AdminInvestorRegistrationList from "./admin-investor-registration-list/admin-investor-registration-list";

const AdminInvestorRegistrations = () => {
  return (
    <Switch>
      <Route exact path="/registrations">
        <AdminInvestorRegistrationList />
      </Route>
    </Switch>
  )
}

export default AdminInvestorRegistrations;
